jQuery(document).ready(function () {
    i = 0;
    running = 1;
    jQuery(".__gp .image-wrapper").hover(function () {
        running = 0;
    }, function () {
        running = 1;
    });
    setInterval(function () {
        if (running == 1) {
            jQuery('.__gp .image-wrapper').each(function () {
                height = jQuery(this).find('img').height();
                if ( (200 * i) < height) {
                    jQuery(this).animate({
                        scrollTop: 200 * i
                    }, 600);
                    i++;
                } else {
                    jQuery(this).animate({
                        scrollTop: 0
                    }, 600);
                    i = 0;
                }
            });
        }
    }, 2000);
});
